/**
 * Dragon Tiger bot. There is no skill in the game itself, so bots behave like casual players: a modest bet (a small multiple
 * of the minimum, never more than a tenth of the stack), almost always on Dragon or Tiger, now and then following the last
 * winner, rarely on Tie, and occasionally sitting a round out. The bot only ever reads its own seat's view.
 */
import { chance, type BotEngine } from '../../bots/types.js';
import type { DragonTigerAction, DragonTigerLegal, DragonTigerSide, DragonTigerView } from './engine.js';

export const dragonTigerBot: BotEngine<DragonTigerView, DragonTigerLegal, DragonTigerAction> = {
  decideAction(view, legal, ctx) {
    return this.chooseBet!(view, legal, ctx);
  },

  chooseBet(view, legal, ctx) {
    if (legal.kind !== 'bet') return this.handleTimeout(view, legal, ctx);
    if (legal.canSitOut && chance(ctx, 0.03)) return { type: 'sitOut' };
    const me = view.seat === null ? null : view.players[view.seat];
    const multiple = 1 + ctx.rng.int(ctx.difficulty === 'BEGINNER' ? 4 : 3);
    const cap = me ? Math.max(legal.min, Math.floor(me.chips / 10)) : legal.min;
    const amount = Math.max(legal.min, Math.min(legal.min * multiple, cap, legal.max));
    const last: DragonTigerSide | null = view.lastResult?.winner ?? null;
    let side: DragonTigerSide;
    if (last !== null && last !== 'TIE' && chance(ctx, 0.3)) side = last;
    else {
      const roll = ctx.rng.next();
      side = roll < 0.06 ? 'TIE' : roll < 0.53 ? 'DRAGON' : 'TIGER';
    }
    return { type: 'bet', side, amount };
  },

  evaluateState(view) {
    const me = view.seat === null ? null : view.players[view.seat];
    return me ? Math.max(0, Math.min(1, me.chips / (view.config.minBet * 200))) : 0;
  },

  calculateRisk() {
    return 0;
  },

  handleTimeout() {
    return { type: 'sitOut' };
  },
};
